var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5357 0.0283203H2.46429C1.10379 0.0283203 0 1.1488 0 2.52986V20.8745C0 22.2556 1.10379 23.3761 2.46429 23.3761H20.5357C21.8962 23.3761 23 22.2556 23 20.8745V2.52986C23 1.1488 21.8962 0.0283203 20.5357 0.0283203ZM8.41964 16.9137C5.58058 16.9137 3.28571 14.5842 3.28571 11.7022C3.28571 8.8202 5.58058 6.49064 8.41964 6.49064C9.8058 6.49064 10.9609 7.00137 11.8594 7.85607L10.4681 9.21628C10.0882 8.84626 9.42589 8.4137 8.42478 8.4137C6.67411 8.4137 5.24687 9.88336 5.24687 11.7074C5.24687 13.5262 6.67411 15.0011 8.42478 15.0011C10.4578 15.0011 11.2176 13.5158 11.3408 12.7549H8.41964V10.9622H13.2661C13.3174 11.2227 13.3482 11.4885 13.3482 11.8273C13.3482 14.8031 11.3819 16.9137 8.41964 16.9137ZM19.7143 12.6507H18.2254V14.162H16.7263V12.6507H15.2375V11.1289H16.7263V9.61757H18.2254V11.1289H19.7143V12.6507Z",
    fill: "#0174EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e3c1d8d1c770eb434450caf12e248787.svg";
export { ForwardRef as ReactComponent };